import type { Role } from '../../types';

// Human labels for roles — no internal taxonomy in client-facing UI. `org_user`
// reads as "Member", etc.
export const ROLE_LABELS: Record<Role, string> = {
  ekom_admin: 'EKOM Admin',
  org_owner: 'Owner',
  org_admin: 'Admin',
  org_user: 'Member',
};

// Ascending privilege on the ORG axis only (mirrors the BE ladder; EKOM_ADMIN is
// the platform axis and absent here).
const ORG_RANK: Partial<Record<Role, number>> = {
  org_user: 0,
  org_admin: 1,
  org_owner: 2,
};

// Roles offered in the invite form, ascending. `org_owner` is deliberately not
// grantable via invite — the one-active-owner invariant means a second owner
// would be rejected at accept, and ownership changes go through transfer, not
// invite. The BE also caps the grant at ≤ the inviter's own role, so we filter
// the ladder to what this inviter actually outranks. Offering only what the BE
// will accept (CLAUDE convention).
const GRANTABLE_LADDER: readonly Role[] = ['org_user', 'org_admin'];

export function grantableRoles(inviterRole: Role): Role[] {
  const inviterRank = ORG_RANK[inviterRole];
  if (inviterRank === undefined) return [];
  return GRANTABLE_LADDER.filter((role) => {
    const rank = ORG_RANK[role];
    return rank !== undefined && rank <= inviterRank;
  });
}
